import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, ValidatorFn, ValidationErrors, FormGroupDirective, NgForm } from '@angular/forms';
import { Http } from "@angular/http";
import { Headers } from '@angular/http';
import * as _ from 'lodash';
import { ApiService } from '../api.service';
import { Process } from 'src/app/model/process-model/process.model';
import { IMMEventService } from '../immEevent-service/imm-event.service';
import { ErrorStateMatcher } from '@angular/material';


/** Error when invalid control is dirty, touched, or submitted. */
export class CrossFieldErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Injectable({
  providedIn: 'root'
})
export class ProcessService {

  errorMatcher = new CrossFieldErrorMatcher();

  constructor(
    private http: Http,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private eventService: IMMEventService
  ) { }

  private apiDomain = ApiService.getDomainName();
  // private eventId = this.apiService.getEventId();
  eventStartDate: any;

  getEvent() {
    const eventId = this.apiService.getEventId();
    this.eventService.findById(eventId).then(
      res => {
        this.eventStartDate = res.startDate;
        console.log(this.eventStartDate);
      }
    )
  }

  form: FormGroup = new FormGroup({
    id: new FormControl(null),
    processName: new FormControl('', [Validators.required, Validators.minLength(2)]),
    startDate: new FormControl('', Validators.required),
    endDate: new FormControl('', Validators.required),
    processSeq: new FormControl('')
  }, { validators: this.dateRangeValidator });

  // eventDateValidate: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  //   this.eventStartDate = control.get('eventStartDate');
  //   const startDate = control.get('startDate');
  //   return this.eventStartDate && startDate && startDate.value < this.eventStartDate.value ? { 'eventDateValidator': true } : null;
  // };

  // dateRangeValidator(group: FormGroup) {
  //   if ((group.get('startDate').value!= '' && group.get('endDate').value!= '') && group.get('startDate').value > group.get('endDate').value) {
  //     // return {
  //     //   invalidDate: "Start Date should be less than End Date"
  //     // };
  //     alert("End date should be grater then start date");
  //   }
  //   return {};
  // }
  dateRangeValidator(control: FormGroup) {
    const invalid = control.get('startDate').value > control.get('endDate').value;
    return invalid ? { invalidDate: true } : null;
  }

  isDate(control: FormGroup) {
    console.debug('startDate ==> ', control.get('startDate') && control.get('startDate').value)
    console.debug('endDate ==> ', control.get('endDate') && control.get('endDate').value)
    console.debug('isvalid = ', control.valid);
    console.debug('control = ', control);
    let invalidDate = false;

    if (!(
      control.get('startDate') &&
      control.get('endDate') &&
      control.get('startDate').value &&
      control.get('endDate').value &&
      !isNaN(new Date(control.get('startDate').value).getTime()) &&
      !isNaN(new Date(control.get('endDate').value).getTime())
    )) {
      invalidDate = true;
    }

    return invalidDate ? { invalidDate: true } : null;
    
  }


  private handleError(error: any): Promise<Array<any>> {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error._body);
    }
  }

  findAll(): Promise<Array<Process>> {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    const eventId = this.apiService.getEventId();
    return this.http.get(this.apiDomain + "/ims/api/" + eventId + "/process/", { headers })
      .toPromise()
      .then(response => response.json() as Process[])
      .catch(this.handleError);
  }

  findById(processId): Promise<Array<Process>> {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/process/" + processId, { headers })
      .toPromise()
      .then(response => response.json() as Process[])
      .catch(this.handleError);
  }

  createProcess(process: Process): Promise<Array<Process>> {
    let processHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    let dataObject = "[" + JSON.stringify(process) + "]";
    const eventId = this.apiService.getEventId();
    return this.http.post(this.apiDomain + "/ims/api/" + eventId + "/process/", dataObject, { headers: processHeaders })
      .toPromise()
      .then(response => response.json() as Process[])
      .catch(this.handleError);
  }

  updateProcess(process: Process, processId) {
    let processHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/process/" + processId, JSON.stringify(process), { headers: processHeaders })
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  deleteProcess(id) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    const url = this.apiDomain + "/ims/api/process/" + id
    return this.http.delete(url, { headers })
      .toPromise()
      .then(response => response.json() as Process[])
      .catch(this.handleError);
  }

  findAllShortlistedCandidates(processId) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/" + processId + "/shortlistedCandidate/", { headers })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  availableCandidateForReAssignment(panelId) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/availableCandidateForReAssignment/" + panelId, { headers })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }
}
